import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-5">
            What is Sugargoo Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            A Sugargoo spreadsheet is a carefully organized collection of product links that helps
            shoppers browse and discover items available through the Sugargoo shopping platform.
            Instead of manually searching for products one by one, these spreadsheets give you
            instant access to curated lists covering everything from sneakers to fashion accessories.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
            <div className="bg-background-50 rounded-xl p-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                <i className="ri-flashlight-line text-lg"></i>
              </div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-2">Fast Access</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Skip the manual search and browse pre-organized product categories instantly
              </p>
            </div>
            <div className="bg-background-50 rounded-xl p-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-3">
                <i className="ri-list-check-2 text-lg"></i>
              </div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-2">Organized Lists</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Products grouped by category so you can find exactly what you need quickly
              </p>
            </div>
            <div className="bg-background-50 rounded-xl p-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                <i className="ri-refresh-line text-lg"></i>
              </div>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-2">Updated Links</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Regularly refreshed product links to keep you connected to the latest inventory
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Benefit</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-100">
                <td className="px-6 py-3.5 text-foreground-700">Fast Access</td>
                <td className="px-6 py-3.5 text-foreground-600">Saves browsing time significantly</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="px-6 py-3.5 text-foreground-700">Organized Lists</td>
                <td className="px-6 py-3.5 text-foreground-600">Easy to navigate and find products</td>
              </tr>
              <tr>
                <td className="px-6 py-3.5 text-foreground-700">Updated Links</td>
                <td className="px-6 py-3.5 text-foreground-600">Always fresh product selections</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}